import Page from './index';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	// auth: authRoles.user,
	routes: [
		{
			path: '/assets-dashboard',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/contracts-dashboard',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/iot-dashboard',
			exact: true,
			component: Page.Layout
		},
	]
};